import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import DisabilitySelectionViewModel from '../ViewModels/DisabilitySelectionViewModel';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Checkbox from '@material-ui/core/Checkbox';
import CloseIcon from '@material-ui/icons/Close';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    },
    cardContent: {
        paddingBottom: "16px !important"
    },
    closeGridItem: {
        textAlign: "end"
    }
});


interface IDisabilitySelectionCardProps {
    disability: DisabilitySelectionViewModel;
    setPrimary: (id: number) => void;
    delete: (id: number) => void;
}

interface IDisabilitySelectionCardState {
}

class DisabilitySelectionCard extends Component<IDisabilitySelectionCardProps & WithStyles<typeof styles>, IDisabilitySelectionCardState> {
    constructor(props) {
        super(props);
        
    }

    componentDidMount() {
    }

    public render() {
        var classes = this.props.classes;

        return (
            <Card variant="outlined">
                <CardContent className={classes.cardContent}>
                    <Grid container >
                        <Grid item xs={6}>
                            <p>{this.props.disability.disabilityDisplay}</p>
                        </Grid>
                        <Grid item xs={4}>
                            <FormControlLabel
                                label="Primary disability"
                                control={
                                    <Checkbox
                                        checked={this.props.disability.isPrimary}
                                        value="isPrimary"
                                        name="isPrimary"
                                        color="primary"
                                        onChange={this.setPrimary}
                                    />
                                }
                            />
                        </Grid>
                        <Grid item xs={2} className={classes.closeGridItem}>
                            <IconButton onClick={this.deleteDisability}>
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        );
    }

    public deleteDisability = () => {
        if (this.props.disability.disabilityId !== undefined) {
            this.props.delete(this.props.disability.disabilityId);
        }
    }

    public setPrimary = () => {
        if (this.props.disability.disabilityId !== undefined) {
            this.props.setPrimary(this.props.disability.disabilityId);
        }
    }
}

export default withStyles(styles)(DisabilitySelectionCard);